module.exports = __webpack_public_path__ + "static/media/Me-to-Me.0c00c639.mp4";